import { baseApi } from './baseApi';

export const noticeBoardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNoticeBoards: builder.query({
      query: () => '/api/notice_boards',
      providesTags: ['NoticeBoards'],
    }),
    getNoticeBoardById: builder.query({
      query: (id) => `/api/notice_boards/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'NoticeBoards', id }],
    }),
  }),
});

export const { useGetNoticeBoardsQuery, useGetNoticeBoardByIdQuery } =
  noticeBoardApi;

